import React, { ComponentProps, Fragment } from "react";

interface Props extends ComponentProps<typeof Fragment> {
  condition?: boolean;
}

const ConditionalFragment: React.FC<Props> = ({
  condition,
  children,
  ...props
}) => {
  if (!condition) return null;

  return <Fragment {...props}>{children}</Fragment>;
};

export default ConditionalFragment;
